export default __webpack_public_path__ + "static/media/FS_Logo_White.02778290.png";